import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { List as ListComponent } from "../../sharedComponents/List";
import * as styles from "./List.module.scss";

const ListTheme = ["sun", "tide", "rock", "checklist"];
const ListStyle = ["dotted", "arrowed", "buttons", "none"];

const List = ({ children, className, listType, theme, listStyle }) => (
	<ListComponent
		className={cx({
			[styles.list]: listType === "unordered",
			[styles[theme]]: theme && styles[theme],
			[styles[listStyle]]: listStyle && styles[listStyle],
			[className]: className,
		})}
		listType={listType}
		variant={listType}
		theme={theme}
		listStyle={listStyle}>
		{children}
	</ListComponent>
);
List.Item = ListComponent.Item;
List.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	className: PropTypes.string,
	listType: PropTypes.oneOf(["unordered", "ordered"]),
	theme: PropTypes.oneOf([...ListTheme]),
	listStyle: PropTypes.oneOf([...ListStyle]),
};
List.defaultProps = {
	className: "",
	listType: "unordered",
	theme: "sun",
	listStyle: "dotted",
};

export default List;
export { List, ListStyle };
